import React from 'react';
import { Box, Flex } from '../Rebass';
import { SxStyleProp } from '../Rebass/types';
import SectionHeading from '../SectionHeading';

interface SectionProps {
  id?: string;
  headline?: string;
  headlineLineTwo?: string;
  description?: string;
  children?: React.ReactNode;
  renderCta?: React.ReactNode;
  direction?: 'row' | 'column';
  textContainerSx?: SxStyleProp & { width?: number | string };
  childrenContainerSx?: SxStyleProp & { width?: number | string };
  headlineSize?: string;
  headingStyles?: {
    headline: SxStyleProp;
    description: SxStyleProp;
  };
  headlineAlignment?: 'left' | 'center';
}

const Section = ({
  id,
  children,
  headline,
  headlineLineTwo,
  description,
  renderCta,
  direction,
  textContainerSx = {},
  childrenContainerSx = {},
  headlineAlignment = 'left',
  headlineSize = 'h2',
  headingStyles,
  ...rest
}: SectionProps) => {
  const isRow = direction === 'row';
  return (
    <Flex
      id={id}
      pb={[6, 6, 6, 16]}
      pt={[4]}
      flexDirection={['column', 'column', direction]}
      justifyContent={'space-between'}
      alignItems="flex-start"
      {...rest}
    >
      {headline || description ? (
        <Box
          className="sectionLayout"
          width={textContainerSx.width || (isRow ? [1, 1, 5 / 12] : [1])}
          sx={{
            ...(isRow
              ? {
                  position: ['static', 'static', 'sticky'],
                  top: [1],
                  left: 0,
                }
              : {}),
            ...textContainerSx,
          }}
        >
          <SectionHeading
            headline={headline}
            headlineLineTwo={headlineLineTwo}
            description={description}
            renderCta={renderCta}
            direction={direction}
            alignment={headlineAlignment}
            headlineSize={headlineSize}
            styles={headingStyles}
          />
        </Box>
      ) : null}

      {children && (
        <Box
          width={childrenContainerSx.width || (isRow ? [1, 1, 8 / 12] : [1])}
          sx={{ ...childrenContainerSx }}
        >
          {children}
        </Box>
      )}
    </Flex>
  );
};

Section.defaultProps = {
  headline: '',
  headlineLineTwo: '',
  description: '',
  children: null,
  renderCta: null,
  direction: 'column',
  headlineSize: 'h2',
};

export default Section;
